<template>
  <v-container>
    <div v-if="mostraarBarraBotones" class="mt-16" style="margin-botton:-100px;">
      <v-btn
        v-for="(menu, index) in subrutasLista"
        :key="index"
        text
        exact
        class="mr-2 navbar-chido"
        :to="menu.View"
        rounded
        color="blue darken-1"
        dark
        >{{ menu.texto }}</v-btn
      >
    </div>
    <router-view></router-view>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
    subrutasLista() {
      if (this.$store.state.sesion.logedInUserInfo.rol == 1) {
        return this.logedInUserInfo.menus[this.indiceArregloMenus].subrutas;
      }
    },
    mostraarBarraBotones() {
      if (
        this.$store.state.sesion.logedInUserInfo.rol == 1 &&
        (this.$store.state.sesion.logedInUserTokens.accesstoken == null ||
          this.$store.state.sesion.logedInUserTokens.accesstoken == "")
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  data: () => ({
    indiceArregloMenus: 0
  }),
  beforeMount() {
    if (this.mostraarBarraBotones) {
      let arregloCompleto = [];
      for (let i = 0; i < this.logedInUserInfo.menus.length; i++) {
        arregloCompleto.push(this.logedInUserInfo.menus[i].View);
      }
      // this.indiceArregloMenus = arregloCompleto.indexOf('/admin');
      // console.log(this.$route.path,'/admin');
      //TODO esto no es dinámico, esta jarcodeado
      this.indiceArregloMenus = arregloCompleto.indexOf("/admin");
    } else {
      return;
    }
  },
  mounted() {}
};
</script>
<style lang="css"></style>
